<template>
  <div id="app" style="width: 100%">
    <div class="page-header">
      <div class="page-title">角色列表</div>
      <div class="page-header-btn">
        <el-button icon="el-icon-plus" size="mini" style="margin-right: 1rem;" type="primary" @click="add">添加</el-button>
        <el-button icon="el-icon-refresh-right" circle size="mini" :loading="getroleListLoading"
                   @click="getRoleList()"></el-button>
      </div>
    </div>
    <!--设备列表-->
    <el-table :data="roleList" border style="width: 100%;font-size: 12px;" :height="winHeight">
      <el-table-column type="index" label="序号" width="50" align="center" />
      <el-table-column prop="roleKey" label="角色key" align="center"/>
      <el-table-column prop="roleName" label="角色名" align="center"/>
      <el-table-column prop="authority" label="角色权限等级" align="center"/>
      <el-table-column prop="createTime" label="创建时间" align="center" />
      <el-table-column prop="updateTime" label="更新时间" align="center" />

      <el-table-column label="操作" align="center">
        <template slot-scope="{row}">
          <el-button-group>
            <el-button size="mini" icon="el-icon-video-camera-solid" type="primary" @click="edit(row)">修改
            </el-button>
            <el-button size="mini" icon="el-icon-delete" type="danger" @click="del(row)">删除</el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="float: right"
      @size-change="handleSizeChange"
      @current-change="currentChange"
      :current-page="currentPage"
      :page-size="count"
      :page-sizes="[15, 25, 35, 50]"
      layout="total, sizes, prev, pager, next"
      :total="total">
    </el-pagination>
    <roleEdit ref="roleEdit" ></roleEdit>
  </div>
</template>

<script>
import roleEdit from "./dialog/roleEdit";

export default {
  name: "Role",
  components: {
    roleEdit
  },
  data() {
    return {
      roleList: [], //设备列表
      winHeight: window.innerHeight - 200,
      currentPage: 1,
      count: 15,
      total: 0,
      getroleListLoading: false,
    }
  },
  created() {
    this.getRoleList()
  },
  methods:{
    getRoleList(){
      let that = this;
      this.$axios({ method: 'get', url:`/api/role/all` }).then(function (res) {
        that.roleList = res.data.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    currentChange: function (val) {
      this.currentPage = val;
      this.getDeviceList();
    },
    handleSizeChange: function (val) {
      this.count = val;
      this.getDeviceList();
    },
    add(){
      this.$refs.roleEdit.openDialog(null, this.getRoleList)
    },
    edit(row) {
      this.$refs.roleEdit.openDialog(row, this.getRoleList)
    },
    del(row) {
      let that = this;
      this.$confirm('确认删除该数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.getroleListLoading = true;
        this.$axios({ method: 'delete', url:`/api/role/delete`, params: {id: row.id} }).then( res => {
          if (res.data.code === 0){
            that.$message.success("删除成功！")
            this.getRoleList()
          }else {
            that.$message.error(res.data.msg)
          }
          this.getroleListLoading = false;
        })
      })
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Role.vue